import { Tag } from '@app/components/various/Icons';
import { Notification } from '@app/components/various/Notification';
import { NotificationAction } from '@app/components/various/Notification/NotificationAction';
import { useRemoveSelectionProducts } from '@app/services/hooks/selection/useRemoveSelectionProducts';
import { isEmpty } from '@app/utils/isEmpty';
import { Order } from '@typings';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  orderProducts?: Order.Product[];
}

export const CancelledProductsNotification = ({ children, orderProducts = [] }: React.WithOptionalChildren<Props>) => {
  const { t } = useTranslation(['cancelled', 'confirmationConfig']);
  const removeProducts = useRemoveSelectionProducts(orderProducts);

  const defaultMessage = (
    <Trans t={t} i18nKey="cancelled:cancelled_products_alert">
      Some of the products in the Selection <span className="font-medium">have been cancelled</span>
      and they need to be removed before the checkout.
    </Trans>
  );

  return (
    <Notification type="warning" icon={Tag} message={children ?? defaultMessage}>
      {!isEmpty(orderProducts) && (
        <NotificationAction onClick={removeProducts}>
          {t('confirmationConfig:remove_unavailable_variants_from_order.title_other')}
        </NotificationAction>
      )}
    </Notification>
  );
};
